import { useLocation, Link } from 'react-router-dom';
import { Container, Box, Typography } from '@mui/material';
import Breadcrumbs from '@mui/material/Breadcrumbs';
import Stack from '@mui/material/Stack';
import NavigateNextIcon from '@mui/icons-material/NavigateNext';
import { styled } from '@mui/material/styles';
import ImdaApp from '../../assets/json/ImdaIrisApps.json';

// import { useSelector } from 'store';
// import { selectAccount } from 'store/slices/account';

type RouteType = {
    title: string;
    parent: string;
    toPath: string;
};

const ROUTES: RouteType[] = [
    {
        title: 'Home',
        parent: '',
        toPath: '/'
    },
    {
        title: 'Applications',
        parent: 'applications',
        toPath: '/applications'
    },
    {
        title: 'Applications',
        parent: 'application',
        toPath: '/applications'
    },
    {
        title: 'Guides',
        parent: 'guides',
        toPath: '/guides'
    },
    {
        title: 'Guides',
        parent: 'guide',
        toPath: '/guides'
    },
    {
        title: 'Databases',
        parent: 'databases',
        toPath: '/databases'
    },
    {
        title: 'Databases',
        parent: 'database',
        toPath: '/databases'
    },
    {
        title: 'My Applications',
        parent: 'my-applications',
        toPath: '/my-applications'
    },
    {
        title: 'My Applications',
        parent: 'new-application',
        toPath: '/my-applications'
    },
    {
        title: 'My Licences',
        parent: 'my-licences',
        toPath: '/my-licences'
    },
    {
        title: 'Payment',
        parent: 'payment',
        toPath: '/my-licences'
    },
    {
        title: 'Pending Payments',
        parent: 'pending-payments',
        toPath: '/pending-payments'
    }
];

const StyledLink = styled(Link)(({ theme }) => ({
    color: theme.palette.primary[800],
    textDecoration: 'none'
}));

const NavNextIcon = styled(NavigateNextIcon)(({ theme }) => ({
    color: theme.palette.primary[800],
    fontSize: '12px'
}));
const capitalize = (s: any) => s.charAt(0).toUpperCase() + s.slice(1);

function WebBreadcrumbs() {
    // const accountData = useSelector(selectAccount);
    const location = useLocation();
    const dirArray = location.pathname.split('/');
    // const inRoutes = dirArray.length >= 2 && ROUTES.some((route: RouteType) => route.parent === dirArray[dirArray.length - 2]);

    if (location.pathname === '/') return null;

    const breadcrumbs = dirArray.map((dir: string, index) => {
        const pathObj = ROUTES.find((route: RouteType) => route.parent === dir);
        const newDir = dir.toLowerCase() === 'e-advisor' ? dir : dir.split('-').join(' ');
        let customDir;

        if (newDir.toLowerCase() === 'e-advisor') {
            const firstLetter = newDir.split('-')[0];
            const secondLetter = newDir.split('-')[1];
            customDir = [firstLetter.toLowerCase(), capitalize(secondLetter)].join('-');
        }

        const pathName =
            pathObj?.title === 'My Applications' || pathObj?.title === 'My Licences' ? [pathObj.title] : pathObj?.title.split(' ') || '';
        const pathLink = pathObj?.toPath || '/';
        if (index === dirArray.length - 1) {
            if (location.pathname.split('/')[1] === 'guide' || location.pathname.split('/')[1] === 'application') {
                const { title = '' } = ImdaApp?.find(({ path }) => path === dir) ?? {};
                return (
                    <Typography key={`breadcrumb-${dir}`} sx={{ color: '#592A71' }}>
                        {title}
                    </Typography>
                );
            }

            if (dir.toLowerCase() === 'e-advisor') {
                return (
                    <Typography key={`breadcrumb-${dir}`} sx={{ color: '#592A71' }}>
                        {dir.toLowerCase() === 'e-advisor' && customDir
                            ? customDir
                            : newDir
                                  .split(' ')
                                  .map((text) => {
                                      return text.charAt(0).toUpperCase() + text.substring(1);
                                  })
                                  .join(' ')}
                    </Typography>
                );
            }

            if (dir.toLowerCase() === 'newspaper-register-search') {
                return (
                    <Typography key={`breadcrumb-${dir}`} sx={{ color: '#592A71' }}>
                        Newspaper Register Search
                    </Typography>
                );
            }

            if (dir.toLowerCase() === 'newspaper-register-confirmation') {
                return (
                    <Typography key={`breadcrumb-${dir}`} sx={{ color: '#592A71' }}>
                        Newspaper Register Confirmation
                    </Typography>
                );
            }

            return (
                <Typography key={`breadcrumb-${dir}`} sx={{ color: '#592A71' }}>
                    {dir.toLowerCase() === 'my-licences' || dir.toLowerCase() === 'my-applications'
                        ? newDir
                              .split(' ')
                              .map((text) => {
                                  return decodeURIComponent(text.charAt(0).toUpperCase() + text.substring(1));
                              })
                              .join(' ')
                        : newDir
                              .split(' ')
                              .map((text) => {
                                  return decodeURIComponent(text.charAt(0).toUpperCase() + text.substring(1));
                              })
                              .join('/')}
                </Typography>
            );
        }
        if (pathName[0] === 'Payment') {
            return (
                <Typography key={`breadcrumb-${dir}`} sx={{ color: '#592A71' }}>
                    {pathName}
                </Typography>
            );
        }
        return (
            <StyledLink key={`breadcrumb-${dir}`} to={pathLink}>
                {pathName}
            </StyledLink>
        );
    });
    return (
        <Box sx={{ background: '#F7F7F7' }} id="breadcrumb">
            <Container sx={{ p: '10px 16px' }}>
                <Stack spacing={2}>
                    <Breadcrumbs separator={<NavNextIcon />} aria-label="breadcrumb" sx={{ fontWeight: '600' }}>
                        {breadcrumbs}
                    </Breadcrumbs>
                </Stack>
            </Container>
        </Box>
    );
}

export default WebBreadcrumbs;
